export const sideArguments = {
  a: [
    { point: "行为本身站得住脚", detail: "在规则允许的范围内表达态度，比默默配合更容易被看见，也更容易推动讨论。" },
    { point: "观众有知情权", detail: "观众投入了时间和情绪，事件双方至少应该给出一个能自圆其说的说法。" },
    { point: "情绪不是原罪", detail: "被舆论推到风口浪尖时，任何人的反应都可能不那么体面，这不该被无限放大。" },
  ],
  b: [
    { point: "连带影响被忽略了", detail: "个人选择往往由整个团队一起承担后果，评价时不能只看单方面。" },
    { point: "信息并不完整", detail: "我们看到的只是被剪过、被转述过的片段，用片段下结论本身就不严谨。" },
    { point: "讨论容易失控", detail: "一旦具体指向被放大，讨论就会从「聊事情」变成「针对人」，这不是我们想看到的。" },
  ],
};

export const topicComments = [
  {
    id: "c-1",
    nickname: "瓜田老农",
    side: "a",
    content: "先别急着定性，把时间线捋清楚再说。目前能确认的信息其实非常有限。",
    time: "1 小时前",
    likes: 428,
  },
  {
    id: "c-2",
    nickname: "理性吃瓜第7年",
    side: "b",
    content: "我站另一边。大家容易忽略的是，这件事牵扯到的从来不只是一个人。",
    time: "2 小时前",
    likes: 316,
  },
  {
    id: "c-3",
    nickname: "深夜刷直播",
    side: "a",
    content: "说实话两边都有道理，但情绪化表达真的解决不了任何问题。",
    time: "3 小时前",
    likes: 205,
  },
  {
    id: "c-4",
    nickname: "赛博显微镜",
    side: "b",
    content: "提醒一下，讨论可以激烈，但不要出现具体指向和隐私信息，会被折叠的。",
    time: "4 小时前",
    likes: 512,
  },
  {
    id: "c-5",
    nickname: "追剧不睡觉",
    side: "a",
    content: "等一个正式回应。在那之前，所有「实锤」我都先标个存疑。",
    time: "5 小时前",
    likes: 178,
  },
];

export const relatedTopics = [
  { id: "t-1004", title: "综艺剪辑被指「恶剪」，观众拿原片逐帧对比后炸了", heat: "6.9万" },
  { id: "t-1005", title: "某头部账号被扒「人设崩塌」，粉丝却在评论区集体控评？", heat: "6.1万" },
  { id: "t-1006", title: "两位演员发布会全程零互动，是「真有矛盾」还是「尴尬营业」？", heat: "5.6万" },
  { id: "t-1008", title: "粉丝应援花墙被拆，是「公共秩序优先」还是「矫枉过正」？", heat: "4.2万" },
];